import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';
import { Image } from './image';

export class AmenityDetail {
    constructor(doc)
    {
		this.label = null;
		this.amenityAreaMeasure = null;
		this.amenityAttachedToManufacturedHomeIndicator = null;
		this.amenityCount = null;
		this.amenityMaterialType = null;
		this.amenityMaterialTypeOtherDescription = null;
		this.amenityType = null;
		this.amenityTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.amenityAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:AmenityAreaMeasure");
		this.amenityAttachedToManufacturedHomeIndicator = x.getBooleanElement(doc, "./ns:AmenityAttachedToManufacturedHomeIndicator");
		this.amenityCount = x.getIntegerElement(doc, "./ns:AmenityCount");
		this.amenityMaterialType = x.getStringElement(doc, "./ns:AmenityMaterialType");
		this.amenityMaterialTypeOtherDescription = x.getStringElement(doc, "./ns:AmenityMaterialTypeOtherDescription");
		this.amenityType = x.getStringElement(doc, "./ns:AmenityType");
		this.amenityTypeOtherDescription = x.getStringElement(doc, "./ns:AmenityTypeOtherDescription");
   }
}

export class SwimmingPoolFeature {
    constructor(doc)
    {
		this.label = null;
		this.swimmingPoolFeatureType = null;
		this.swimmingPoolFeatureTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.swimmingPoolFeatureType = x.getStringElement(doc, "./ns:SwimmingPoolFeatureType");
		this.swimmingPoolFeatureTypeOtherDescription = x.getStringElement(doc, "./ns:SwimmingPoolFeatureTypeOtherDescription");
   }

	GetFeature() {
		return h.descriptionOrOther(this.swimmingPoolFeatureType, this.swimmingPoolFeatureTypeOtherDescription);
	}

}

export class Amenity {
    constructor(doc)
    {
		this.label = null;
		this.amenityDetail = null;
		this.images = [];
		this.swimmingPoolFeatures = [];
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:AMENITY_DETAIL");
		if (node !== null)
				this.amenityDetail = new AmenityDetail(node);
		nodes = x.selectNodes(doc, "./ns:IMAGES/ns:IMAGE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.images.push(new Image(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:SWIMMING_POOL_FEATURES/ns:SWIMMING_POOL_FEATURE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.swimmingPoolFeatures.push(new SwimmingPoolFeature(xn));
			});
		}
   }

	GetAmenityType() {
		return h.descriptionOrOther(this.amenityDetail.amenityType, this.amenityDetail.amenityTypeOtherDescription);
	}

	GetAmenityTypeAndCount() {
		let type = h.descriptionOrOther(this.amenityDetail.amenityType, this.amenityDetail.amenityTypeOtherDescription);
			let count = this.amenityDetail.amenityCount; 
			if (count) 
				type = h.addWithSpacer(type, count, "-");
		return type
	}

	GetMaterialType() {
		return h.descriptionOrOther(this.amenityDetail.amenityMaterialType, this.amenityDetail.amenityMaterialTypeOtherDescription);
	}

	GetAmenityDetails(categoryType, bManufacturedHome = false) {
		//console.log(categoryType, this.amenityDetail);
		let types = [];
		let details = "";
		if (categoryType === "OutdoorAccessories") {
			types = ["Fence", "IrrigationSystem", "OutdoorFireplace", "OutdoorKitchen", "OutdoorRidingRing", "SportsCourt"];
			if (types.includes(this.amenityDetail.amenityType)) {
				details = this.amenityDetail.amenityAreaMeasure.ToString();

				if (this.amenityDetail.amenityCount > 0) 
					details = h.addWithSpacer(details, "Total Number - " + this.amenityDetail.amenityCount);

				if (bManufacturedHome) {
					if (this.amenityDetail.amenityAttachedToManufacturedHomeIndicator ?? false)
						details += "\nAttached To Manufactured Home";
					else
						details += "\nNot Attached To Manufactured Home";
				}
				return details;
			}
		}

		if (categoryType === "OutdoorLiving") {
			types = ["Balcony", "Deck", "Gazebo", "Patio", "Porch"];
			if (types.includes(this.amenityDetail.amenityType)) {
				details = this.amenityDetail.amenityAreaMeasure.ToString();

				if (this.amenityDetail.amenityCount > 0) 
					details = h.addWithSpacer(details, "Total Number - " + this.amenityDetail.amenityCount);

				if (bManufacturedHome) {
					if (this.amenityDetail.amenityAttachedToManufacturedHomeIndicator ?? false)
						details += "\nAttached To Manufactured Home";
					else
						details += "\nNot Attached To Manufactured Home";
				}
				return details;
			}
		}

		if (categoryType === "WholeHome")	{
			types = ["EVStation", "Elevator", "FireSuppressionSystem", "IndoorFireplace", "MultipleZoneHeatingVentilationAndAirConditioning", "SmartHomeSystem", "WhileHouseVentilation", "WoodStove"];
			if (types.includes(this.amenityDetail.amenityType)) {
				if (this.amenityDetail.amenityCount > 0)
					return "Total Number - " + this.amenityDetail.amenityCount;
			}
		}

		if (categoryType === "WaterFeatures") {
			details = "";
			types = ["IngroundPool", "IngroundSpa", "Sauna", "OutdoorShower"];
			if (types.includes(this.amenityDetail.amenityType)) {
				if (this.SwimmingPoolFeatures !== null)
					for (var spf of this.swimmingPoolFeatures)
						details = h.addWithSpacer(details, spf.GetFeature());
				if (this.amenityDetail.amenityCount > 0)
					return "Total Number - " + this.amenityDetail.amenityCount;
			}
			return details;
		}

		if (categoryType === "Miscellaneous")
		{
			types = ["Airstrip", "ClubMembership", "SharedLaundryFacilities", "Other"];
			if (types.includes(this.amenityDetail.amenityType)) {
				if (this.amenityDetail.amenityCount > 0)
					return "Total Number - " + this.amenityDetail.amenityCount;
			}
		}

		return "";
		}

	GetSwimmingPoolFeatures() {
		var list = "";
		if (this.swimmingPoolFeatures.length === 0) return list;
		for (var spf of this.swimmingPoolFeatures)
			list = h.addWithSpacer(list, spf.GetFeature());

		return list;
	}

}

export class AmenityCategoryDetail {
    constructor(doc)
    {
		this.label = null;
		this.amenityCategoryType = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.amenityCategoryType = x.getStringElement(doc, "./ns:AmenityCategoryType");
   }
}

export class AmenityCategory {
    constructor(doc)
    {
		this.label = null;
		this.amenities = [];
		this.amenityCategoryDetail = null;
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:AMENITIES/ns:AMENITY");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.amenities.push(new Amenity(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:AMENITY_CATEGORY_DETAIL");
		if (node !== null)
				this.amenityCategoryDetail = new AmenityCategoryDetail(node);
  }

	GetAmenityList() {
		var list = "";
		for (var amenity of this.amenities)
			list = h.addWithSpacer(list, amenity.GetAmenityTypeAndCount());

		return list;
	}

	GetAmenityCategoryType() {
		return h.toEnumText(this.amenityCategoryDetail.amenityCategoryType);
	}

}

export class PropertyAmenity {
    constructor(doc)
    {
		this.label = null
		this.amenityCategories = []
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:AMENITY_CATEGORIES/ns:AMENITY_CATEGORY");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.amenityCategories.push(new AmenityCategory(xn));
			});
		}
   }

 GetCategory(category) {
		if (this.amenityCategories.length === 0) return null;
		for (let c of this.amenityCategories)
			if (c.amenityCategoryDetail.amenityCategoryType === category)
				return c;
		return null;
	 }

 	GetAmenityList(category) {
		var list = [];
		if (this.amenityCategories.length === 0) return list;
		for (let c of this.amenityCategories)
			if (c.amenityCategoryDetail.amenityCategoryType === category)
				for (var amenity of c.amenities) {
					list = h.addWithSpacer(list, amenity.GetAmenityTypeAndCount());
					let spf = amenity.GetSwimmingPoolFeatures();
					if (spf) list = h.addWithSpacer(list, spf, ' - ')
				}
		return list;
	}
}

